module.exports = __webpack_public_path__ + "img/logo.196ee4df.196ee4df.png";